import React, { useState } from "react";

const ContactPopup = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [countryCode, setCountryCode] = useState("+91"); // default

  const handleSubmit = (e) => {
    e.preventDefault();

    const fullPhone = `${countryCode}${phone}`;
    const yourBusinessNumber = "919825772794"; // 🔁 Replace with your WhatsApp number

    const message = `Hi! I just submitted my details:\nEmail: ${email}\nPhone: ${fullPhone}\nPlease get in touch with me.`;
    const encodedMessage = encodeURIComponent(message);

    // Open WhatsApp in new tab
    window.open(`https://wa.me/${yourBusinessNumber}?text=${encodedMessage}`, "_blank");

    if (typeof window.gtag === "function") {
      window.gtag("event", "conversion", {
        send_to: "AW-759404552/q3tmCLm87JYcEIiwjuoC",
      });
    }

    // Optionally log for dev
    console.log("Submitted ->", { email, fullPhone });

    onClose(); // close popup
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="m-2  bg-white rounded-2xl shadow-xl w-full max-w-md p-6 relative z-50">
        {/* Close button */}
        <button
          className="absolute top-4 right-4 text-gray-500 hover:text-gray-700 text-2xl"
          onClick={onClose}
        >
          &times;
        </button>

        {/* Header */}
        <div className="text-center mb-6">
          <h2 className="text-xl font-semibold text-gray-800">
            Build your journey with us!
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Get updates, expert tips, and personalized guidance.
          </p>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            placeholder="Enter your email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="w-full px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />

          <div className="flex gap-2">
            <select
              value={countryCode}
              onChange={(e) => setCountryCode(e.target.value)}
              className="w-1/3 px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="+91">+91</option>
              <option value="+1">+1</option>
              <option value="+44">+44</option>
            </select>
            <input
              type="tel"
              placeholder="Mobile number"
              required
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              className="w-2/3 px-4 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            type="submit"
            className="w-full py-2 px-4 bg-blue-800 text-white rounded-md hover:bg-blue-900 transition duration-200"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactPopup;
